import { render, staticRenderFns } from "./IsMobile.vue?vue&type=template&id=15a706e8"
import script from "./IsMobile.vue?vue&type=script&lang=js"
export * from "./IsMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports